<template>
  <div
    class="grid grid-cols-[auto_1fr] rounded overflow-hidden border p-2 gap-3"
  >
    <div
      class="flex shrink-0 h-[9rem] aspect-[3/4] skeleton-loading-bg rounded"
    />
    <div class="flex flex-col">
      <div class="flex flex-col gap-2 flex-grow">
        <div class="flex flex-col gap-1">
          <div
            class="font-bold h-5 w-20 text-base line-clamp-1 skeleton-loading-bg rounded"
          />
          <div
            class="text-base-content/50 h-4 w-10 skeleton-loading-bg rounded"
          />
        </div>
        <div class="w-full flex-grow flex flex-col gap-1">
          <div class="skeleton-loading-bg h-4 w-full rounded" />
          <div class="skeleton-loading-bg h-4 w-full rounded" />
          <div class="skeleton-loading-bg h-4 w-[50%] rounded" />
        </div>
      </div>
    </div>
  </div>
</template>
